import React, { useState } from 'react';

import { Card } from '@apigrowfinance/pbolt-card';
import { usePermission } from '@apigrowfinance/pbolt-permission-provider';
import { AxiosError } from 'axios';

import { useAccount } from '@contexts/AccountProvider';
import useGetCustomers from '@hooks/queries/useGetCustomers';
import useGetFlexControls from '@hooks/queries/useGetFlexControls';
import ControlTypeModal from '@pages/accountDetail/tabs/controls/addControls/ControlTypeModal';
import Controls from '@pages/accountDetail/tabs/controls/Controls';
import is404Response from '@utils/is404Response';

import FlexControlChips from './FlexControlChips';

const ControlsContainer = () => {
    const { account } = useAccount();
    const { isAllowedTo } = usePermission();

    const [selectedCustomer, setSelectedCustomer] = useState<number | null>(
        null,
    );

    const [controlTypeModalOpen, setControlTypeModalOpen] = useState(false);

    const { data: customerData, isLoading: isCustomerLoading } =
        useGetCustomers(account?.account_id);

    const { data, error, isFetching } = useGetFlexControls(
        account?.account_id,
        selectedCustomer,
    );

    const is404Error =
        (error as AxiosError)?.response &&
        is404Response((error as AxiosError)?.response);
    const isNon404Error =
        (error as AxiosError)?.response &&
        !is404Response((error as AxiosError)?.response);

    return (
        <>
            <Card isBottomRadiusBorder={false} isTopRadiusBorder={false}>
                <FlexControlChips
                    displayAddButton={
                        isAllowedTo('create.flexControl') && !is404Error
                    }
                    onSelect={setSelectedCustomer}
                    isLoadingCustomers={isCustomerLoading}
                    customers={customerData?.items}
                    selectedCustomer={selectedCustomer}
                    setControlTypeModalOpen={setControlTypeModalOpen}
                />
            </Card>
            <Controls
                data={data}
                isLoading={isFetching}
                selectedCustomerId={selectedCustomer}
                noResults={is404Error}
                isError={isNon404Error}
                setControlTypeModalOpen={setControlTypeModalOpen}
            />
            <ControlTypeModal
                controlTypeModalOpen={controlTypeModalOpen}
                setControlTypeModalOpen={setControlTypeModalOpen}
                customers={customerData?.items}
            />
            <Card isTopRadiusBorder={false} paddingSize="small" />
        </>
    );
};

export default ControlsContainer;
